export default {
    props: {
        format: {
            type: String,
            required: false
        }
    }
}
